import { getCodeList } from "country-list";
import { tz } from "moment-timezone";

export function guessUserCountry() {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    for (const country of tz.countries()) {
        const timeZones = tz.zonesForCountry(country);
        if (timeZones.includes(userTimeZone)) {
            return country.toUpperCase();
        }
    }

    return "US";
}

export function getAllCountryCodes() {
    return Object.entries(getCodeList())
        .map(([code, name]) => ({ code: code as string, name: name as string }))
        .sort((a, b) => a.name.localeCompare(b.name));
}
